import { render, staticRenderFns } from "./PlotItemDetail.vue?vue&type=template&id=004778a2&scoped=true"
import script from "./PlotItemDetail.vue?vue&type=script&lang=ts"
export * from "./PlotItemDetail.vue?vue&type=script&lang=ts"
import style0 from "./PlotItemDetail.vue?vue&type=style&index=0&id=004778a2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "004778a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004778a2')) {
      api.createRecord('004778a2', component.options)
    } else {
      api.reload('004778a2', component.options)
    }
    module.hot.accept("./PlotItemDetail.vue?vue&type=template&id=004778a2&scoped=true", function () {
      api.rerender('004778a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/PlotItemDetail.vue"
export default component.exports